<template>
  <div>
    <div>
      <div>
        <div class="searchBox">
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="top"
            size="mini"
            ref="searchForm"
            label-width="130px"
            :model="searchObj"
          >
            <el-row :gutter="10">
              <el-col :xs="12" :lg="6">
                <el-form-item label="所在区县">
                  <el-select v-model="searchObj.region" filterable clearable>
                    <el-option
                      v-for="item in seatList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="国民经济行业">
                  <el-select
                    v-model="searchObj.industry_type"
                    placeholder="请选择"
                    clearable
                    :disabled="sshyCodeDef !== ''"
                  >
                    <el-option
                      v-for="item in industryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="登记注册类型">
                  <el-select
                    v-model="searchObj.registerType"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in registerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="时间选择">
                  <el-date-picker
                    class="jiance_phone_date"
                    :editable="false"
                    :clearable="false"
                    v-model="searchObj.date_range"
                    type="month"
                    value-format="yyyy-MM"
                    :picker-options="pickerOptions"
                    placeholder="选择月"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否规上">
                  <el-select
                    v-model="searchObj.aboveScale"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否上市">
                  <el-select
                    v-model="searchObj.listed"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否军工">
                  <el-select
                    v-model="searchObj.military"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业规模">
                  <el-select
                    v-model="searchObj.companySize"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="大型" value="大型"></el-option>
                    <el-option label="中型" value="中型"></el-option>
                    <el-option label="小型" value="小型"></el-option>
                    <el-option label="微型" value="微型"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业类别">
                  <el-select
                    v-model="searchObj.companyCategory"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="50户重点" value="50户重点"></el-option>
                    <el-option label="小巨人" value="小巨人"></el-option>
                    <el-option label="专精特新" value="专精特新"></el-option>
                    <el-option label="隐形冠军" value="隐形冠军"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业性质">
                  <el-select
                    v-model="searchObj.companyNature"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="国有" value="国有"></el-option>
                    <el-option label="民营" value="民营"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="“565”产业" clearable>
                  <el-cascader
                    v-model="searchObj.company565"
                    :options="Company565List"
                    :props="deftProps"
                    placeholder="请选择"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否超10亿元">
                  <el-select
                    v-model="searchObj.oneBillion"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="12" :lg="6">
                <el-form-item label="提质倍增">
                  <el-select
                    v-model="searchObj.multiplication"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="市级" value="市级"></el-option>
                    <el-option label="区县级" value="区县级"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="店小二服务">
                  <el-select
                    v-model="searchObj.xiaoerService"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="三大改造实施">
                  <el-select
                    v-model="searchObj.threeChanges"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      label="智能化改造"
                      value="智能化改造"
                    ></el-option>
                    <el-option
                      label="绿色化改造"
                      value="绿色化改造"
                    ></el-option>
                    <el-option label="技术改造" value="技术改造"></el-option>
                    <el-option label="未实施" value="未实施"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item class="phone_button_box">
                  <div class="phone_button" style="margin-top: 37px">
                    <el-button
                      type="primary"
                      @click="onSearch"
                      class="bg5584FF formBotton"
                      >查询</el-button
                    >
                    <el-button type="info" @click="onReset" class="formBotton"
                      >重置</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row style="margin: 10px 0px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            :height="tableData.length > 0 ? 420 : 180"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            stripe
            :data="tableData"
          >
            <el-table-column
              type="index"
              label="序号"
              fixed
              width="50"
            ></el-table-column>
            <el-table-column prop="NAME" fixed label="企业"></el-table-column>
            <el-table-column :label="`工业总产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="this_month_gyzcz"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                min-width="120"
                :formatter="handelFix2"
                prop="last_year_month_gyzcz"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix1"
                min-width="120"
                prop="gyzczRate"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`工业销售产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="this_month_gyxscz"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="120"
                prop="last_year_month_gyxscz"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="gyxsczRate"
                :formatter="handelFix1"
                min-width="120"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`营业收入${unitStr}`">
              <el-table-column
                sortable
                prop="this_month_yysr"
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="last_year_month_yysr"
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="yysrRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`利润总额${unitStr}`">
              <el-table-column
                sortable
                prop="this_month_lrze"
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                prop="last_year_month_lrze"
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="lrzeRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`营业税金及附加${unitStr}`">
              <el-table-column
                prop="this_month_yysj"
                min-width="100"
                sortable
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_yysj"
                :formatter="handelFix2"
                min-width="120"
                sortable
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="yysjRate"
                min-width="120"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column :label="`应缴增值税${unitStr}`">
              <el-table-column
                prop="this_month_zzs"
                :formatter="handelFix2"
                min-width="100"
                sortable
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_zzs"
                :formatter="handelFix2"
                min-width="120"
                sortable
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="zzsRate"
                min-width="120"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="企业用电量（万千瓦时）">
              <el-table-column
                prop="this_month_qyydl"
                sortable
                min-width="100"
                :formatter="handelFix2"
                label="当期"
              ></el-table-column>
              <el-table-column
                prop="last_year_month_qyydl"
                sortable
                min-width="120"
                :formatter="handelFix2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                prop="qyydlRate"
                sortable
                min-width="120"
                :formatter="handelFix1"
                label="同比增速(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column fixed="right" label="企业表" width="60">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row, '001')"
                  type="text"
                  size="small"
                  >产值表</el-button
                >
                <el-button
                  style="margin-left: 0"
                  @click="handleClick(scope.row, '002')"
                  type="text"
                  size="small"
                  >财务表</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <div class="pageBox">
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[20, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="20"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div>
    <el-dialog
      v-if="showDialogVisible"
      title="查看"
      append-to-body
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      :width="screenWidth < 1200 ? '96%' : '1160px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow v-if="editCode == '001'" :id="editId"></zdquczbShow>
      <zdjcqycwbShow v-if="editCode == '002'" :id="editId"></zdjcqycwbShow>
    </el-dialog>
  </div>
</template>
<script>
import quarter from "@/components/dateUtils/quarter.vue";
import zdquczbShow from "@/views/Index/Workbench/DataCollection/DataWrite/notInsert/zdquczbShow/index";
import zdjcqycwbShow from "@/views/Index/Workbench/DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    industryTypeDef: {
      type: String,
      default: "",
    },
    registerTypeDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
    sshyCodeDef: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      Company565List: [],
      searchObj: {
        industry_type: this.sshyCodeDef,
        date_range: this.timesDef.split(",")[0] || this.getNowQuarter(),
        page: 1,
        pageSize: 20,
      },
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      exportLabel: "<<点击此处可导出报表",
      showArea: false,
      showDialogVisible: false,
      areaName: "",
      industry_type: this.industryTypeDef,
      companyNature: "",
      companyName: "",
      total: 1,
      currentPage: 1,
      registerType: this.registerTypeDef,
      unit: "1",
      unitStr: "（千元）",
      srcDataList: "",
      industryList: [],
      registerList: [],
      page: 1,
      pageSize: 20,
      editCode: "",
      editId: "",
      dialogTableVisible: false,
      queryData: {
        page: this.page,
        pageSize: this.pageSize,
      },
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataRange: this.dataRangeDef || "month", //数据类型
      times: this.timesDef, //时间
      year: "", //时间
      yearDef: "", //时间
      quarter: "", //时间
      quarterDef: "", //时间
      mountDef: "", //时间
      defaultQuarterValue: [], //时间
      defaultMonthValue: "", //时间
      QuarterValue: [],
      loading: false,
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "千元",
      },
    };
  },
  components: {
    // quarter,
    zdquczbShow,
    zdjcqycwbShow,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  methods: {
    onSearch() {
      this.initData();
    },
    getAreaList() {
      // 区县列表
      this.$axios
        .get("/business//park/seat")
        .then((res) => {
          this.$store.commit("setAreaLsit", res.data);
        })
        .catch((res) => {
          console.log("区县列表获取失败", res);
        });
    },
    handleClick(row, type) {
      this.editCode = type;
      if (type === "001") {
        this.editId = row.czbId;
      } else {
        this.editId = row.cwbId;
      }
      console.log(this.editCode, this.editId, row);
      this.showDialogVisible = true;
    },
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      console.log("-------------------", row[column.property]);
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    unitChange(value) {
      if (value === "1") {
        this.unitStr = "（千元）";
      } else if (value === "0.1") {
        this.unitStr = "（万元）";
      } else if (value === "0.00001") {
        this.unitStr = "（亿元）";
      }
      this.getShowData();
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      console.log(this.pageSize);
      this.initData();
    },
    changePage() {
      this.page = this.currentPage;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.initData();
    },
    getSelectList() {
      //获取下拉列表
      // 园区列表
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.parkList = res.data;
      });
      // 国民经济行业列表
      this.$axios.get("/business/project/industry").then((res) => {
        this.industryList = res.data;
      });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
      //565列表
      this.$axios.get("/business/company/selectCompany565List").then((res) => {
        this.Company565List = res.data;
      });
    },
    onReset() {
      this.searchObj = {
        industry_type: this.sshyCodeDef,
        date_range: this.timesDef.split(",")[0] || this.getNowQuarter(),
        page: this.page,
        pageSize: this.pageSize,
      };

      // debugger;
      // this.companyName = ''
      // this.companyNature = ''
      // this.industry_type = this.industryTypeDef
      // this.registerType = this.registerTypeDef
      this.unit = "1";
      (this.unitStr = "（千元）"),
        (this.times = this.timesDef || this.mountDef);
      // this.year = this.yearDef
      // this.quarter = this.quarterDef
      // this.dataRange = this.dataRangeDef || 'month'
      // delete this.queryData.companyName
      // delete this.queryData.industry_type
      // delete this.queryData.companyNature
      // delete this.queryData.registerType
      console.log(this.page);
      this.initData();
    },
    initData() {
      const self = this;
      this.loading = true;
      // if (this.companyName) {
      //     this.queryData.companyName = this.companyName
      // }
      // if (this.industry_type) {
      //     this.queryData.industry_type = this.industry_type
      // }
      // if (this.companyNature) {
      //     this.queryData.companyNature = this.companyNature
      // }
      // if (this.registerType) {
      //     this.queryData.registerType = this.registerType
      // }
      // this.queryData.dateType = this.dataRange
      // this.queryData.month = this.times
      // this.queryData.year = this.year
      // this.queryData.quarter = this.quarter
      this.searchObj.page = this.page;
      this.searchObj.pageSize = this.pageSize;
      this.$axios
        .post("/business/companyMonitor/queryByCompany2", this.searchObj)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: "千元",
          };
          this.showArea = false;
          this.srcDataList = res.data;
          this.total = res.total;
          this.getShowData();
          this.loading = false;
        });
    },
    disabledDate(time) {
      return time.getTime() > Date.now();
    },
    getQuarter(value) {
      this.year = value.slice(0, 4);
      const tmp = value.slice(5, 7);
      if (tmp === "01") {
        this.quarter = 1;
      } else if (tmp === "04") {
        this.quarter = 2;
      } else if (tmp === "07") {
        this.quarter = 3;
      } else if (tmp === "10") {
        this.quarter = 4;
      }
      this.initData();
    },
    getShowData() {
      this.tableData = [];
      this.srcDataList.forEach((item) => {
        const obj = {
          NAME: item.NAME,
          czbId: item.czbId,
          cwbId: item.cwbId,
        };
        obj.this_month_gyzcz = item.this_month_gyzcz * this.unit;
        obj.last_year_month_gyzcz = item.last_year_month_gyzcz * this.unit;
        obj.this_month_yysr = item.this_month_yysr * this.unit;
        obj.last_year_month_yysr = item.last_year_month_yysr * this.unit;
        obj.this_month_yysj = item.this_month_yysj * this.unit;
        obj.last_year_month_yysj = item.last_year_month_yysj * this.unit;
        obj.this_month_lrze = item.this_month_lrze * this.unit;
        obj.last_year_month_lrze = item.last_year_month_lrze * this.unit;
        obj.this_month_zzs = item.this_month_zzs * this.unit;
        obj.last_year_month_zzs = item.last_year_month_zzs * this.unit;
        obj.this_month_gyxscz = item.this_month_gyxscz * this.unit;
        obj.last_year_month_gyxscz = item.last_year_month_gyxscz * this.unit;
        obj.this_month_qyydl = item.this_month_qyydl;
        obj.last_year_month_qyydl = item.last_year_month_qyydl;
        obj.gyzczRate =
          item.last_year_month_gyzcz > 0
            ? ((item.this_month_gyzcz - item.last_year_month_gyzcz) /
                item.last_year_month_gyzcz) *
              100
            : "--";
        obj.yysrRate =
          item.last_year_month_yysr > 0
            ? ((item.this_month_yysr - item.last_year_month_yysr) /
                item.last_year_month_yysr) *
              100
            : "--";
        obj.yysjRate =
          item.last_year_month_yysj > 0
            ? ((item.this_month_yysj - item.last_year_month_yysj) /
                item.last_year_month_yysj) *
              100
            : "--";
        obj.lrzeRate =
          item.last_year_month_lrze > 0
            ? ((item.this_month_lrze - item.last_year_month_lrze) /
                item.last_year_month_lrze) *
              100
            : "--";
        obj.zzsRate =
          item.last_year_month_zzs > 0
            ? ((item.this_month_zzs - item.last_year_month_zzs) /
                item.last_year_month_zzs) *
              100
            : "--";
        obj.gyxsczRate =
          item.last_year_month_gyxscz > 0
            ? ((item.this_month_gyxscz - item.last_year_month_gyxscz) /
                item.last_year_month_gyxscz) *
              100
            : "--";
        obj.qyydlRate =
          item.last_year_month_qyydl > 0
            ? ((item.this_month_qyydl - item.last_year_month_qyydl) /
                item.last_year_month_qyydl) *
              100
            : "--";
        this.tableData.push(obj);
      });
      console.log("this.tableData:", this.tableData);
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      var results = "";
      if (month < 10) {
        results = year + "-0" + month;
      } else {
        results = year + "-" + month;
      }
      console.log("results:", results);
      return results;
      /*  //下面是几个if
                  let year = this.times.slice(0, 4)
                  this.year = year
                  this.yearDef = year
                  const month = parseInt(this.times.split('-').pop())
                  //下面是几个if
                  if(month >=1 && month <=3){
                      this.quarter = 1
                      this.quarterDef = 1
                      return year + '-' + '01' + ',' + year + '-' + '03';
                  }
                  else if (month >=4 && month <=6){
                      this.quarter = 2
                      this.quarterDef = 2
                      return year + '-' + '04' + ',' + year + '-' + '06';
                  }else if (month >=7 && month <=9){
                      this.quarter = 3
                      this.quarterDef = 3
                      return year + '-' + '07' + ',' + year + '-' + '09';
                  }else if (month >=10 && month <=12){
                      this.quarter = 4
                      this.quarterDef = 4
                      return year + '-' + '10' + ',' + year + '-' + '12';
                  }*/
    },
    exportData() {
      const column = [
        {
          title: "企业",
          key: "NAME",
          rowspan: 2,
        },
        {
          title: "工业总产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyzcz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyzcz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyzczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "工业销售产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyxscz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyxscz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyxsczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业收入" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysr",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysr",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysrRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "利润总额" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_lrze",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_lrze",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "lrzeRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业税金及附加" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysj",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysj",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysjRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "应缴增值税" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_zzs",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_zzs",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "zzsRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "企业用电量（万千瓦时）",
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_qyydl",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_qyydl",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "qyydlRate",
            },
          ],
          colspan: 3,
        },
      ];
      let timeStr = "";
      console.log("**********", this.year);
      console.log("**********");
      if (this.dataRange === "year") {
        timeStr = this.year + "年";
      } else if (this.dataRange === "quarter") {
        timeStr = this.year + "年第" + this.quarter + "季度";
      } else {
        timeStr =
          this.searchObj.date_range.slice(0, 4) +
          "年" +
          this.searchObj.date_range.slice(5, 7) +
          "月";
      }
      export2Excel(column, this.tableData, this.title + "_" + timeStr);
    },
  },
  created() {
    // this.defaultQuarterValue = this.getNowQuarter()
    this.getSelectList();
    this.initData();
    this.getAreaList();
    if (this.regionCodeDef) {
      this.queryData.region = this.regionCodeDef;
    } else if (this.registerTypeDef) {
      this.queryData.registerType = this.registerTypeDef;
    } else if (this.industryTypeDef) {
      this.queryData.industry_type = this.industryTypeDef;
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style lang="less" scoped>
.topBtnBox {
  display: flex;
  justify-content: space-between;
  i.show {
    animation: showRotate 0.5s forwards;
  }
  i.close {
    animation: closeRotate 0.5s forwards;
  }
}
@keyframes showRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(180deg);
  }
}
@keyframes closeRotate {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0);
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 30px 0 20px;
}
.searchBox {
  overflow: hidden;
  height: auto;
  background-color: rgba(173, 173, 173, 0.02);
  border-radius: 2px;
  // border: 1px solid rgba(114, 114, 114, 0.15);
  // .el-form {
  //   margin-top: 10px;
  //   display: flex;
  //   justify-content: space-between;
  //   flex-wrap: wrap;
  //   div:nth-last-child(1) {
  //     box-sizing: border-box;
  //   }
  //   .el-form-item {
  //     width: 220px;
  //   }
  //   .item {
  //     width: 37%;
  //     display: flex;
  //     .el-form-item.halfOne {
  //       width: 55%;
  //       display: flex;
  //     }
  //     .el-form-item.halfTwo {
  //       width: 45%;
  //       display: flex;
  //     }
  //   }
  // }
}
.search-leave-active,
.search-enter-active {
  transition: all 0.8s ease;
}
.search-leave-active,
.search-enter {
  height: 0px !important;
}
.search-leave,
.search-enter-active {
  height: 420px;
}
.hr-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.2s;
}
.hr-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.hr-enter,
.hr-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.search {
  width: 40%;
  margin-bottom: 15px;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .phone_button_box {
    display: block;
    width: 186px;
    margin: 0 auto 20px;
  }
  .phone_button {
    margin-top: 0 !important;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>